// Material-table compontent extracted to get needed funcionality for ProjectsDialog.js component

/* eslint-disable no-unused-vars */
import * as React from "react";
import PropTypes from "prop-types";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import { Box, Button, Checkbox, Divider, Switch } from "@material-ui/core";
import OptimizedTooltip from "../../common/OptimizedTooltip";
import { connect } from "react-redux";
/* eslint-enable no-unused-vars */

class MTableAction extends React.Component {
  render() {
    let action = this.props.action;
    const { selected, selectedLength, handleEdit, handleDelete } = this.props;

    if (typeof action === "function") {
      action = action(this.props.data);
      if (!action) {
        return null;
      }
    }

    if (action.action) {
      action = action.action(this.props.data);
      if (!action) {
        return null;
      }
    }

    if (action.hidden) {
      return null;
    }

    const disabled =
      action.disabled ||
      this.props.disabled ||
      selectedLength >= 2 ||
      (!selected && selectedLength === 1);

    const handleOnClick = (event, disabled) => {
      event.stopPropagation();
      if (action.onClick && !disabled) {
        if (action.tooltip === "Edit") {
          handleEdit(this.props.data);
        } else if (action.tooltip === "Delete") {
          handleDelete(this.props.data);
        } else {
          action.onClick(event, this.props.data);
        }
      }
    };

    let icon;
    let button;

    if (action.icon === "Select") {
      button = (
        <Box
          order="3"
          display="flex"
          alignItems="center"
          className={"checkbox-wrapper"}
        >
          <Checkbox
            className={this.props.classes.checkbox}
            checked={selected}
            value="secondary"
            color="primary"
            disabled={action.disabled || this.props.disabled}
            // data-cy={"projects-select"}
            onClick={e => {
              e.stopPropagation();
              if (action.onClick) {
                action.onClick(e, this.props.data);
              }
            }}
          />
          <Divider
            orientation="vertical"
            style={{ height: 20, marginRight: 6 }}
          />
        </Box>
      );
    } else if (action.icon === "Switch") {
      button = (
        <OptimizedTooltip
          title={
            (this.props.data.is_enable ? "Disable" : "Enable") + " template"
          }
        >
          <Button>
            <Switch
              name="switch"
              color="primary"
              checked={this.props.data.is_enable}
              onChange={e => {
                e.stopPropagation();
                if (action.onClick) {
                  action.onClick(e, this.props.data);
                }
              }}
            />
          </Button>
        </OptimizedTooltip>
      );
    } else {
      icon =
        typeof action.icon === "string" ? (
          <Icon {...action.iconProps}>{action.icon}</Icon>
        ) : typeof action.icon === "function" ? (
          action.icon({ ...action.iconProps, disabled: disabled })
        ) : (
          <action.icon />
        );

      button = !Object.keys(this.props.data).length ? (
        <Button
          size={this.props.size}
          color="inherit"
          className={disabled ? "action-disabled" : ""}
          onClick={event => handleOnClick(event, disabled)}
        >
          {icon}
        </Button>
      ) : (
        <IconButton
          size={this.props.size}
          color="inherit"
          className={disabled ? "action-disabled" : ""}
          onClick={event => handleOnClick(event, disabled)}
        >
          {icon}
        </IconButton>
      );
    }

    if (action.tooltip) {
      return action.tooltip === "Delete" ? (
        <OptimizedTooltip title={action.tooltip}>
          <span>{button}</span>
        </OptimizedTooltip>
      ) : disabled ? (
        button
      ) : (
        <OptimizedTooltip title={action.tooltip}>{button}</OptimizedTooltip>
      );
    } else {
      return button;
    }
  }
}

MTableAction.defaultProps = {
  action: {},
  data: {}
};

MTableAction.propTypes = {
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object)
  ]),
  disabled: PropTypes.bool,
  size: PropTypes.string
};

export default MTableAction;
